var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-file-ics"},[_c('div',[_c('input',{staticClass:"input",attrs:{"type":"file","id":_vm.accommodation.idalojamiento},on:{"change":_vm.handleChange}}),_c('div',{staticClass:"fake-button"},[_vm._v("Upload ICS")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }